import React from "react";

import "react-whatsapp-widget/dist/index.css";

import { Style } from "react-style-tag";
import { connect } from "react-redux";

import Draggable from "react-draggable";
import Button from "@material-ui/core/Button";

import WhatsappIcon from "./assests/whatsappIcon.png";

class Index extends React.Component {
  state = {
    shouldShow: false,
    dragging: false,
  };

  componentDidMount = () => {
    setTimeout(() => this.setState({ shouldShow: true }), 50);
  };

  handleLinkClick = () => {
    let whatsapp_number =
      this.props.branch_whatsapp_number || this.props.store_whatsapp_number;

    if (whatsapp_number.startsWith("+")) {
      whatsapp_number = whatsapp_number.substring(1);
    }

    const url = `https://api.whatsapp.com/send?phone=${whatsapp_number}`;
    const ua = navigator.userAgent || navigator.vendor || window.opera;

    const isInAppBrowser =
      ua.includes("Instagram") || ua.includes("FBAN") || ua.includes("FBAV");

    if (isInAppBrowser) {
      window.location.href = url;
    } else {
      window.open(url, "_blank");
    }
  };

  onDrag = () => {
    if (!this.state.dragging) this.setState({ dragging: true });
  };

  onStop = () => {
    const { dragging } = this.state;
    this.setState({ dragging: false });

    if (!dragging) {
      this.handleLinkClick();
    }
  };

  render() {
    const { language, storeName, storeArName, enabled } = this.props;
    let { branch_whatsapp_number, store_whatsapp_number } = this.props;

    if (!enabled || (!branch_whatsapp_number && !store_whatsapp_number)) {
      return null; // Return null if not enabled or no WhatsApp number
    }

    let whatsapp_number = branch_whatsapp_number || store_whatsapp_number;
    if (whatsapp_number.startsWith("+")) {
      whatsapp_number = whatsapp_number.substring(1);
    }

    return (
      <div>
        <Style>
          {`
            ._1bpcM {
              ${language == "english" ? "right" : "left"}: 0px !important;
              border-radius: ${
                language === "english" ? "5px 0px 0px 5px" : "0px 5px 5px 0px"
              } !important;
            }

            ._2iWL7 {
              ${language == "english" ? "right" : "left"}: 30px !important;
              direction: ${language == "english" ? "ltr" : "rtl"} !important;
            }

            ._nYEjV {
              text-align: ${
                language == "english" ? "left" : "right"
              } !important;
            }

            ._1w7Ch {
              top: 15px !important;
              ${language == "english" ? "right" : "left"}: 10px !important;
            }

            @media (max-width: 450px) {
              ._2iWL7 {
                left: 45% !important;
                width: 92.5% !important;
                transform: translate(-50%, 0) !important;
              }
            }
          `}
        </Style>

        {this.state.shouldShow && (
          <div>
            <Draggable axis="y" onDrag={this.onDrag} onStop={this.onStop}>
              <div className="_1bpcM" style={{ display: "flex" }}>
                <Button className="p-0">
                  <img src={WhatsappIcon} alt="WhatsApp" />
                </Button>
              </div>
            </Draggable>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    storeName: state.store.store.name,
    storeArName: state.store.store.ar_name || state.store.store.name,
    enabled: state.store.store.settings.enable_whatsapp_widget,
    store_whatsapp_number: state.store.store.settings.link_whatsapp,
    branch_whatsapp_number: state.store.store.whatsapp_number,
  };
};

export default connect(mapStateToProps)(Index);
